import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SiteMapStore } from '../../site-map.store';
import { kpiGradientCss } from '../../utils/kpi-scale';

@Component({
  selector: 'app-site-map-kpi-panel',
  standalone: true,
  templateUrl: './kpi-panel.component.html',
  styleUrls: ['./kpi-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, NgSelectModule, TranslateModule],
})
export class SiteMapKpiPanelComponent {
  protected readonly store = inject(SiteMapStore);
  protected readonly gradient = kpiGradientCss();
}
